export const config =
    {
      rowSelection: false,
      pagination: false,
      fieldControl: false,
      tableType: 'antd',
      search: false,
      columns: [
        {
          title: '项目/通项',
          dataIndex:['object', 'showName'],
          width: 200
        },
        {
          title: '类型',
          dataIndex: ['object', 'busTypeStr'],
          width: 160
        },
        {
          title: '适用门店',
          dataIndex: ['object', 'subPackDetail'],
          render: 'jsonRender',
          width: 200
        },
        {
          title: '创建人',
          dataIndex: ['object', 'createdByName'],
          width: 160
        },
        {
          title: '创建时间',
          dataIndex: ['object', 'createdTime'],
          width: 180,
          itemType: 'dateTime'
        },
        {
          title: '操作',
          dataIndex:  ['object', 'busType'],
          render: 'actionRender',
          fixed: 'right',
          width: 160
        },
      ],
    }